import React, { useEffect, useState } from "react";
import { useSocket } from "./useSocket";

export const useCricketScorecardSocket = (socketUrl, matchId) => {
    const [scorecardData, setScorecardData] = useState(null);
    const socket = useSocket(socketUrl);

    useEffect(() => {
        if (socket && matchId) {
            console.log("Cricket Scorecard socket connected");
            const channelName = "CricketMatch";
            const eventName = `CricketMatchScorecard-${matchId}`;

            socket.channel(channelName).listen(eventName, (newData) => {
                console.log("Socket data received:", newData);
                setScorecardData(newData?.data);
            });
            return () => {
                socket?.connector?.socket.disconnect();
            };
        }
    }, [socket, matchId]);

    return scorecardData;
};
